import { ContentManagement, Sizes } from "../API/TsConfig";

export const enum DeviceLayoutPreference {
  Desktop = "desktop",
  Tablet = "tablet",
  Phone = "phone",
  PhoneAutogen = "phoneAutogen",
}

const emptyDashboardSize: Sizes = {
  maxWidth: 0,
  maxHeight: 0,
  minWidth: 0,
  minHeight: 0,
};

export function getSizeConstraints(
  tsConfig: ContentManagement,
  isAuthoring: boolean,
  layout: DeviceLayoutPreference
): Sizes {
  // Most of this logic is duplicated from ViewerController.getSizeToUse. Ideally it would only live here,
  // but currently we still need getSizeToUse to calculate the lytebox sizing styles.
  if (isAuthoring) {
    return emptyDashboardSize;
  }

  // The ShowLytebox check does not correspond to any equivalent logic in getSizeToUse -- this is added
  // here to preserve the pre-TFSID 861194 behavior for the lytebox as much as possible.
  // The problem is that the lytebox sizing is not responsive -- it assumes that the size of the sheet
  // never changes, which is no longer true now that we're adapting the size constraints on navigation to
  // a new sheet whenver tabs aren't showing. Without this check, switching to a sheet with a width larger
  // than the old sheet's causes the lytebox overflow horizontally, breaking the centering.
  else if (tsConfig.showTabs || tsConfig.showLytebox) {
    return tsConfig.composite_sizes[layout];
  } else {
    const sheetName = !tsConfig.current_sheet_name
      ? decodeURIComponent(tsConfig.sheetId)
      : tsConfig.current_sheet_name;

    const sheetViewSize = tsConfig.view_sizes[sheetName];
    if (sheetViewSize) {
      return sheetViewSize[layout];
    }
  }
  return emptyDashboardSize;
}
